import { useMessagesStore } from '../stores/messages.store'

export function useMessages() {
  const messages = useMessagesStore((state) => state.messages)
  const unreadCounts = useMessagesStore((state) => state.unreadCounts)
  const activePartner = useMessagesStore((state) => state.activePartner)
  const isLoading = useMessagesStore((state) => state.isLoading)
  const isSending = useMessagesStore((state) => state.isSending)
  const adminContact = useMessagesStore((state) => state.adminContact)

  const setActivePartner = useMessagesStore((state) => state.setActivePartner)
  const fetchConversation = useMessagesStore((state) => state.fetchConversation)
  const sendMessage = useMessagesStore((state) => state.sendMessage)
  const markAsRead = useMessagesStore((state) => state.markAsRead)
  const fetchUnreadCounts = useMessagesStore((state) => state.fetchUnreadCounts)
  const fetchAdminContact = useMessagesStore((state) => state.fetchAdminContact)
  const addMessage = useMessagesStore((state) => state.addMessage)
  const updateMessageRead = useMessagesStore((state) => state.updateMessageRead)
  const clearConversation = useMessagesStore((state) => state.clearConversation)

  return {
    messages,
    unreadCounts,
    activePartner,
    isLoading,
    isSending,
    adminContact,
    setActivePartner,
    fetchConversation,
    sendMessage,
    markAsRead,
    fetchUnreadCounts,
    fetchAdminContact,
    addMessage,
    updateMessageRead,
    clearConversation,
  }
}
